export default [
  {
    path: '/front-covers',
    name: 'front-cover',
    meta: { requiresAuth: true },
    component: () => import('@/pages/front-cover/index')
  }
]
